import { Component, Input } from '@angular/core';

import { MatTooltipModule } from '@angular/material/tooltip';
import { CmUiChipComponent } from '@cm/ui-modules';
import { Label } from '@shared/models/label.model';

@Component({
  selector: 'app-label-chip',
  templateUrl: './label-chip.component.html',
  styleUrls: ['./label-chip.component.scss'],
  standalone: true,
  imports: [MatTooltipModule, CmUiChipComponent],
})
export class LabelChipComponent {
  @Input({ required: true }) label!: Label;
}
